function activateSubnavigation(selector) {
  $('.navigation--secondary-menu.-active').removeClass('-active')
  $(selector).eq(0).addClass('-active')
}

function openOrCloseSubnavigationMenu(selector) {
  let $currentlyOpen = closeSubnavigationMenu()
  let $target = $(selector)

  if ($target.get(0) !== $currentlyOpen.get(0)) {
    $target.addClass('-open')
  }
}

function closeSubnavigationMenu() {
  return $('.navigation--secondary-menu.-open').removeClass('-open')
}

up.compiler('.navigation', (navigation) => {
  const $navigation = $(navigation)

  let $body = $('body') // binding to body because of https://github.com/unpoly/unpoly/issues/24

  let scrollbarWidth = window.innerWidth - $navigation.width()
  $navigation.css('width', `calc(100vw - ${scrollbarWidth}px`)

  function setActiveSubnavigation() {
    setTimeout(() => {
      closeSubnavigationMenu()
      activateSubnavigation($navigation.find('.navigation--secondary-menu:has(.up-current)'))
    })
  }

  function onClickDocument(event) {
    if ($(event.target).closest('.tour, .tour-backdrop').length) return
    if ($navigation.find(event.target).length === 0) setActiveSubnavigation()
  }

  function onClickNavigation(event) {
    // Clicking a .navigation--spacer inside the primary menu should revert any switched secondary menu.
    // The event won't target .navigation--spacer, but hit .navigation--row instead.
    if ($(event.target).is('.navigation--primary-menu .navigation--row')) setActiveSubnavigation()
  }

  $navigation.on('click', onClickNavigation)
  $body.on('click', onClickDocument)

  setActiveSubnavigation()

  return [
    () => { $body.off('click', onClickDocument) },
    up.on('up:framework:booted, up:location:changed', setActiveSubnavigation),
  ]

})

up.macro('.navigation--primary-menu a', (element, subsectionSelector) => {
  const $element = $(element)

  $element.attr('title', $element.text().replace(/\s+/g, ' ').trim())

  $element.on('click', () => {
    activateSubnavigation(subsectionSelector)
    openOrCloseSubnavigationMenu(subsectionSelector)
  })

})
